import { parse } from "date-fns";
import { omitBy } from "lodash-es";
import { casesActions } from "configs";
import { useCurrentCase, useDispatch, useParams } from "duck";
import { useUpdateVitalMutation } from "requests";

export const useUpdateVitals = (caseCreationDate?: Date) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [update] = useUpdateVitalMutation();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (
    curValue: number | null,
    cellValue: any,
    name: string,
    time: string
  ) => {
    if (cellValue?.vitalId && caseCreationDate) {
      const isHeartRate = name === "HR";
      const isRespiratoryRate = name === "RR";
      const isPulseOximetry = name === "SpO2";
      const isEndTidal = name === "End-Tidal CO2";
      const isSystolicBloodPressure = name === "SBP";
      const isMeanBloodPressure = name === "MBP";
      const isDiastolicBloodPressure = name === "DBP";

      const timeMonitoring = parse(
        time,
        "h:mm a",
        caseCreationDate
      ).toISOString();

      const variables = omitBy(
        {
          timeMonitoring,
          ...(isHeartRate ? { heartRate: curValue } : {}),
          ...(isRespiratoryRate ? { respiratoryRate: curValue } : {}),
          ...(isPulseOximetry ? { pulseOximetry: curValue } : {}),
          ...(isEndTidal ? { endTidal: curValue } : {}),
          ...(isSystolicBloodPressure
            ? { systolicBloodPressure: curValue }
            : {}),
          ...(isMeanBloodPressure ? { meanBloodPressure: curValue } : {}),
          ...(isDiastolicBloodPressure
            ? { diastolicBloodPressure: curValue }
            : {})
        },
        value => value === undefined
      );

      if (shouldSync) {
        dispatch(
          casesActions.updateVitals({
            data: {
              _id: cellValue.vitalId,
              ...variables
            },
            _id: caseId
          })
        );

        return update({
          variables: {
            input: {
              _id: cellValue.vitalId,
              ...variables
            }
          }
        });
      }

      dispatch(
        casesActions.updateVitals({
          data: {
            ...(typeof cellValue.vitalId === "number"
              ? { _id: cellValue.vitalId }
              : { fakeId: cellValue.vitalId }),
            ...variables
          },
          _id: caseId
        })
      );
    }
  };
};
